import { Event } from "../../models/events";
import { computeEventEndDate } from "../eventSchedule";

export const formatDate = (date?: Date | string) => {
  const transform = new Date(date || "").toLocaleString();

  return transform;
};

export const formatDateWithoutSeconds = (date?: Date | string) => {
  const parsed = new Date(date || "");
  if (isNaN(parsed.getTime())) return "";

  const formattedDate = parsed.toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const formattedTime = parsed.toLocaleTimeString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} ${formattedTime}`;
};

export const parseDate = (dateString: string) => {
  const parsedDate = new Date(dateString);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const toValidDate = (value?: Date | string | null) => {
  if (!value) return null;

  const parsedDate = value instanceof Date ? new Date(value) : new Date(value);

  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const mergeTimeIntoDate = (
  dateValue?: Date | string | null,
  timeValue?: Date | string | null
) => {
  const baseDate = toValidDate(dateValue);
  const timeDate = toValidDate(timeValue);

  if (!baseDate || !timeDate) return null;

  const mergedDate = new Date(baseDate);
  mergedDate.setHours(
    timeDate.getHours(),
    timeDate.getMinutes(),
    timeDate.getSeconds(),
    timeDate.getMilliseconds()
  );

  return mergedDate;
};

export const buildRegistrationDeadlinePayload = (
  minutesBefore: number | null | undefined
) => ({
  registrationDeadline: minutesBefore ?? null,
});

const formatDurationParts = (hours: number, minutes: number) => {
  if (hours === 0 && minutes === 0) return "0";

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const extractHoursAndMinutes = (
  value: string | number | null | undefined
) => {
  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "number") {
    return Number.isFinite(value) ? formatDurationParts(value, 0) : null;
  }

  const normalizedValue = value.trim();
  if (!normalizedValue) return null;

  const timeOnlyValue = normalizedValue.match(/^(\d{1,3})(?::([0-5]?\d))?(?::[0-5]?\d)?$/);
  if (timeOnlyValue) {
    return formatDurationParts(
      Number(timeOnlyValue[1]),
      Number(timeOnlyValue[2] || 0)
    );
  }

  const durationValue = parseDate(normalizedValue);
  if (!durationValue) return null;

  return formatDurationParts(durationValue.getHours(), durationValue.getMinutes());
};

export const correctDateAndHours = (data: Event) =>
  computeEventEndDate(data?.startDate ?? "", String(data?.duration ?? ""));
